import { BANK_CONNECT_PROVIDER } from '../utils/bankConnect';

const plaidProvider = BANK_CONNECT_PROVIDER.PLAID;
const mastercardProvider = BANK_CONNECT_PROVIDER.MASTERCARD;

const CA_FEATURED_INSTITUTIONS = Object.freeze([
    {
      slug: 'rbc-royal-bank',
      name: 'RBC Royal Bank',
      domain: 'rbcroyalbank.com',
      localLogo: '/Bank%20Logos/Canada/RBC.svg',
      bg: 'from-sky-500/14 to-sky-500/4',
      provider: mastercardProvider,
    },
    {
      slug: 'td-canada-trust',
      name: 'TD Canada Trust',
      domain: 'td.com',
      localLogo: '/Bank%20Logos/Canada/TD_Bank.png',
      bg: 'from-emerald-500/14 to-emerald-500/4',
      provider: mastercardProvider,
    },
    {
      slug: 'scotiabank',
      name: 'Scotiabank',
      domain: 'scotiabank.com',
      localLogo: '/Bank%20Logos/Canada/Scotiabank.png',
      bg: 'from-rose-500/14 to-rose-500/4',
      provider: mastercardProvider,
    },
    {
      slug: 'bmo',
      name: 'Bank of Montreal',
      searchName: 'BMO',
      domain: 'bmo.com',
      localLogo: '/Bank%20Logos/Canada/BMO.svg',
      bg: 'from-indigo-500/14 to-indigo-500/4',
      provider: mastercardProvider,
    },
    {
      slug: 'cibc',
      name: 'CIBC',
      domain: 'cibc.com',
      localLogo: '/Bank%20Logos/Canada/CIBC.png',
      bg: 'from-red-500/14 to-red-500/4',
      provider: mastercardProvider,
    },
    {
      slug: 'wealthsimple',
      name: 'Wealthsimple',
      domain: 'wealthsimple.com',
      localLogo: '/Bank%20Logos/Canada/Wealthsimple.png',
      bg: 'from-violet-500/14 to-violet-500/4',
      provider: plaidProvider,
    },
    {
      slug: 'desjardins',
      name: 'Desjardins',
      domain: 'desjardins.com',
      localLogo: '/Bank%20Logos/Canada/Desjardins.png',
      bg: 'from-teal-500/14 to-teal-500/4',
      provider: mastercardProvider,
    },
    {
      slug: 'national-bank-of-canada',
      name: 'National Bank of Canada',
      domain: 'nbc.ca',
      localLogo: '/Bank%20Logos/Canada/National_Bank.png',
      bg: 'from-amber-500/14 to-amber-500/4',
      provider: mastercardProvider,
    },
    {
      slug: 'tangerine',
      name: 'Tangerine',
      domain: 'tangerine.ca',
      localLogo: '/Bank%20Logos/Canada/Tangerine.png',
      bg: 'from-orange-500/14 to-orange-500/4',
      provider: mastercardProvider,
    },
    {
      slug: 'simplii-financial',
      name: 'Simplii Financial',
      domain: 'simplii.com',
      localLogo: '/Bank%20Logos/Canada/Simplii_Financial.png',
      bg: 'from-rose-400/14 to-rose-400/4',
      provider: mastercardProvider,
    },
    {
      slug: 'atb-financial',
      name: 'ATB Financial',
      searchName: 'ATB',
      domain: 'atb.com',
      localLogo: '/Bank%20Logos/Canada/ATB_FInancial.png',
      bg: 'from-blue-500/14 to-blue-500/4',
      provider: mastercardProvider,
    },
    {
      slug: 'coast-capital',
      name: 'Coast Capital',
      domain: 'coastcapitalsavings.com',
      localLogo: '/Bank%20Logos/Canada/Coast%20Capital.png',
      bg: 'from-cyan-500/14 to-cyan-500/4',
      provider: mastercardProvider,
    },
]);

const US_FEATURED_INSTITUTIONS = Object.freeze([
    {
      slug: 'chase',
      name: 'Chase',
      domain: 'chase.com',
      localLogo: '/Bank%20Logos/United%20States/Chase.png',
      bg: 'from-sky-500/14 to-sky-500/4',
      provider: plaidProvider,
    },
    {
      slug: 'capital-one',
      name: 'Capital One',
      domain: 'capitalone.com',
      localLogo: '/Bank%20Logos/United%20States/Capital_One.ico',
      bg: 'from-rose-500/14 to-rose-500/4',
      provider: plaidProvider,
    },
    {
      slug: 'wells-fargo',
      name: 'Wells Fargo',
      domain: 'wellsfargo.com',
      localLogo: '/Bank%20Logos/United%20States/WellsFargo.svg',
      bg: 'from-red-500/14 to-red-500/4',
      provider: plaidProvider,
    },
    {
      slug: 'bank-of-america',
      name: 'Bank of America',
      domain: 'bankofamerica.com',
      localLogo: '/Bank%20Logos/United%20States/Bank_of_America.png',
      bg: 'from-indigo-500/14 to-indigo-500/4',
      provider: plaidProvider,
    },
    {
      slug: 'us-bank',
      name: 'U.S. Bank',
      searchName: 'US Bank',
      domain: 'usbank.com',
      localLogo: '/Bank%20Logos/Bank%20Fallback%20Thumbnails/US_Bank.ico',
      bg: 'from-cyan-500/14 to-cyan-500/4',
      provider: plaidProvider,
    },
    {
      slug: 'citi',
      name: 'Citi',
      domain: 'citi.com',
      localLogo: '/Bank%20Logos/United%20States/Citibank.png',
      bg: 'from-blue-500/14 to-blue-500/4',
      provider: plaidProvider,
    },
    {
      slug: 'ally-bank',
      name: 'Ally',
      searchName: 'Ally Bank',
      domain: 'ally.com',
      localLogo: '/Bank%20Logos/United%20States/Ally_Bank.png',
      bg: 'from-fuchsia-500/14 to-fuchsia-500/4',
      provider: plaidProvider,
    },
    {
      slug: 'navy-federal',
      name: 'Navy Federal Credit Union',
      searchName: 'Navy Federal',
      domain: 'navyfederal.org',
      localLogo: '/Bank%20Logos/United%20States/Navy_Federal_Credit_Union.png',
      bg: 'from-slate-500/14 to-slate-500/4',
      provider: plaidProvider,
    },
    {
      slug: 'pnc-bank',
      name: 'PNC Bank',
      searchName: 'PNC',
      domain: 'pnc.com',
      localLogo: '/Bank%20Logos/United%20States/PNC_Bank.png',
      bg: 'from-orange-500/14 to-orange-500/4',
      provider: plaidProvider,
    },
    {
      slug: 'sofi',
      name: 'SoFi',
      domain: 'sofi.com',
      localLogo: '/Bank%20Logos/United%20States/SoFi.ico',
      bg: 'from-cyan-400/14 to-cyan-400/4',
      provider: plaidProvider,
    },
    {
      slug: 'truist',
      name: 'Truist',
      domain: 'truist.com',
      localLogo: '/Bank%20Logos/United%20States/Truist.jpg',
      bg: 'from-purple-500/14 to-purple-500/4',
      provider: plaidProvider,
    },
    {
      slug: 'usaa',
      name: 'USAA',
      domain: 'usaa.com',
      localLogo: '/Bank%20Logos/United%20States/USSA.png',
      logoScale: 1.22,
      bg: 'from-stone-500/14 to-stone-500/4',
      provider: plaidProvider,
    },
]);

const US_INVESTMENT_FEATURED_INSTITUTIONS = Object.freeze([
  {
    slug: 'charles-schwab',
    name: 'Charles Schwab',
    domain: 'schwab.com',
    localLogo: '/Bank%20Logos/United%20States/Charles_Schwab.png',
    bg: 'from-sky-500/14 to-sky-500/4',
    provider: plaidProvider,
  },
  {
    slug: 'fidelity',
    name: 'Fidelity',
    domain: 'fidelity.com',
    localLogo: '/Bank%20Logos/United%20States/Fidelity.png',
    bg: 'from-emerald-500/14 to-emerald-500/4',
    provider: plaidProvider,
  },
  {
    slug: 'robinhood',
    name: 'Robinhood',
    domain: 'robinhood.com',
    localLogo: '/Bank%20Logos/United%20States/Robinhood.png',
    bg: 'from-lime-500/14 to-lime-500/4',
    provider: plaidProvider,
  },
  {
    slug: 'vanguard',
    name: 'Vanguard',
    domain: 'vanguard.com',
    localLogo: '/Bank%20Logos/United%20States/Vanguard.png',
    bg: 'from-rose-500/14 to-rose-500/4',
    provider: plaidProvider,
  },
  ...US_FEATURED_INSTITUTIONS.slice(0, 7),
  US_FEATURED_INSTITUTIONS.find((institution) => institution.slug === 'truist'),
]);

const CA_INVESTMENT_FEATURED_INSTITUTIONS = Object.freeze([
  {
    ...CA_FEATURED_INSTITUTIONS.find((institution) => institution.slug === 'wealthsimple'),
  },
  {
    slug: 'questrade',
    name: 'Questrade',
    domain: 'questrade.com',
    localLogo: '/Bank%20Logos/United%20States/Questrade.png',
    bg: 'from-fuchsia-500/14 to-fuchsia-500/4',
    provider: plaidProvider,
  },
  ...CA_FEATURED_INSTITUTIONS.filter((institution) => (
    institution.slug !== 'wealthsimple' && institution.slug !== 'coast-capital'
  )),
]);

export const FEATURED_INSTITUTIONS_BY_REGION = Object.freeze({
  CA: CA_FEATURED_INSTITUTIONS,
  US: US_FEATURED_INSTITUTIONS,
});

export const FEATURED_INVESTMENT_INSTITUTIONS_BY_REGION = Object.freeze({
  CA: CA_INVESTMENT_FEATURED_INSTITUTIONS,
  US: US_INVESTMENT_FEATURED_INSTITUTIONS,
});

export const getFeaturedInstitutions = (region = 'US') => (
  FEATURED_INSTITUTIONS_BY_REGION[region] || FEATURED_INSTITUTIONS_BY_REGION.US
);

export const getFeaturedInvestmentInstitutions = (region = 'US') => (
  FEATURED_INVESTMENT_INSTITUTIONS_BY_REGION[region] || FEATURED_INVESTMENT_INSTITUTIONS_BY_REGION.US
);
